import React from 'react';
import { Star } from 'lucide-react';
interface TestimonialProps {
  initials: string;
  name: string;
  location: string;
  text: string;
}
const TestimonialCard = ({
  initials,
  name,
  location,
  text
}: TestimonialProps) => <div className="bg-brand-card p-4 md:p-5 rounded-xl border border-white/10 flex flex-col h-full hover:border-brand-accent/30 transition-colors" data-id="element-274">
    <div className="flex items-center mb-3" data-id="element-275">
      <div className="w-10 h-10 bg-brand-accent text-white rounded-full flex items-center justify-center font-bold text-lg mr-3 shrink-0" data-id="element-276">
        {initials}
      </div>
      <div data-id="element-277">
        <div className="flex text-brand-accent mb-0.5" data-id="element-278">
          {[...Array(5)].map((_, i) => <Star key={i} className="w-3 h-3 fill-current" data-id="element-279" />)}
        </div>
        <p className="font-bold text-white text-sm leading-tight" data-id="element-280">{name}</p>
        <p className="text-[10px] md:text-xs text-gray-500" data-id="element-281">{location}</p>
      </div>
    </div>
    <p className="text-gray-400 text-sm italic flex-grow leading-relaxed" data-id="element-282">
      "{text}"
    </p>
  </div>;
export function TestimonialsSection1() {
  const testimonials = [{
    initials: 'MG',
    name: 'Mariela G.',
    location: 'Córdoba · Escuela Agrotécnica',
    text: 'Organicé todo el año en una tarde. Las evaluaciones con solucionario me ahorran horas cada semana.'
  }, {
    initials: 'LP',
    name: 'Laura P.',
    location: 'Santiago del Estero · Escuela Rural',
    text: 'El Tomo 5 sobre el peronismo y el agro es el más completo que vi. Por fin mis alumnos entienden el IAPI sin que yo tenga que explicarlo diez veces.'
  }, {
    initials: 'RM',
    name: 'Roberto M.',
    location: 'Santa Fe · Orientación Agro y Ambiente',
    text: 'El Tomo 6 sobre el agro actual vale cada peso. Mis alumnos de 5° año debaten sobre la soja y las retenciones con argumentos reales.'
  }];
  return <section className="py-8 md:py-12 px-4 bg-brand-dark" data-id="element-283">
      <div className="max-w-4xl mx-auto" data-id="element-284">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-285">
          {testimonials.map((t, i) => <TestimonialCard key={i} {...t} data-id="element-286" />)}
        </div>
      </div>
    </section>;
}
export function TestimonialsSection2() {
  const testimonials = [{
    initials: 'CR',
    name: 'Cecilia R.',
    location: 'Mendoza · Escuela Técnica Agropecuaria',
    text: 'El Tomo 6 sobre el agro actual me salvó el año. Por fin mis alumnos de 5° pueden debatir sobre la soja y la agricultura familiar con argumentos reales y evidencia histórica.'
  }, {
    initials: 'SC',
    name: 'Sofía C.',
    location: 'Santiago del Estero · Escuela Rural',
    text: 'El caso del MOCASE fue impactante. Mis alumnos reconocieron situaciones de su propia comunidad. Historia nunca había generado tanto debate en el aula.'
  }, {
    initials: 'PA',
    name: 'Pablo A.',
    location: 'Santa Fe · Ciclo Orientado Agro',
    text: 'La Guía Rápida para el Docente es un regalo. Tengo explicadas todas las respuestas orientativas de las actividades. No improviso más en la corrección.'
  }, {
    initials: 'VD',
    name: 'Valeria D.',
    location: 'La Pampa · Colegio Secundario Rural',
    text: 'Dudé por el precio, pero cuando vi que traía 120 actividades listas para imprimir me di cuenta que es baratísimo. Recuperé mis fines de semana. Mi familia, agradecida.'
  }, {
    initials: 'HN',
    name: 'Hernán N.',
    location: 'Córdoba · IPEM Orientación Agro',
    text: 'Los casos reales son oro puro. Usamos el conflicto de 2008 para articular con Ciudadanía y la directora nos felicitó por el proyecto interdisciplinario. Todo el mérito es de este material.'
  }];
  return <section className="py-10 md:py-16 px-4 bg-brand-dark" data-id="element-287">
      <div className="max-w-4xl mx-auto" data-id="element-288">
        <h2 className="text-2xl md:text-3xl font-black text-center mb-8 text-white" data-id="element-289">
          ❤️ MÁS DOCENTES QUE YA LO TIENEN
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6" data-id="element-290">
          {testimonials.map((t, i) => <TestimonialCard key={i} {...t} data-id="element-291" />)}
        </div>
      </div>
    </section>;
}